/**
 * PriceSource define el origen desde donde se resolvió el precio de un producto.
 * Se utiliza para saber si el precio proviene de una lista especial
 * (cliente, grupo de precios, todos los clientes => viene de la tabla 'salesPrices')
 * o si se tomó como fallback el precio base del producto => viene de la tabla 'products'.
 */
export const PriceSource = Object.freeze({
  CLIENT: "CLIENT",
  SCHOOL: "SCHOOL",
  CUSTOMER_PRICE_GROUP: "CUSTOMER_PRICE_GROUP",
  CAMPAIGN: "CAMPAIGN",
  ALL_CUSTOMERS: "ALL_CUSTOMERS",
  PRODUCT: "PRODUCT",
  FALLBACK: "FALLBACK",
});
